import axios from 'axios'
import { ServerEnv } from 'Configs/ServerEnv'
import StoreCountry from 'GlobalStores/Cores/County/StoreCountry'
import StorePaymentStep from 'GlobalStores/Cores/Elements/StorePaymentStep'
import { ObjectHelpers } from 'Helpers/ObjectHelpers'
import { get, isEmpty } from 'lodash'
import { makeAutoObservable, runInAction, toJS } from 'mobx'
import { FeelGreatAPI } from 'Services/FeelGreat/APIs'
import TrackingEvents from 'Services/Tracker/TrackingEvents'
import Payment from '../Payment'
import { PaymentAPIs } from '../PaymentServices/PaymentAPI'
import StoreAuth from 'GlobalStores/User/StoreAuth'
import storeCredit from 'GlobalStores/StoreCredit'
import Cities from 'Components/Elements/Forms/StatesModal/Country/EgyptCities.json'
import StoreCheckout from '../StoreCheckout'
import StoreProducts from 'GlobalStores/StoreProducts'
import storeCheckout from '../StoreCheckout'
import AddressEN from 'Components/Elements/Forms/StatesModal/Country/EgyptAddressEN.json'
import AddressAR from 'Components/Elements/Forms/StatesModal/Country/EgyptAddressAR.json'
import pickupAddress from 'Components/Elements/Forms/StatesModal/Country/EgyptPickupAddress.json'
import StoreTranslate from 'GlobalStores/Cores/Translator/StoreTranslate'

class Egypt {
    autoAddressDisplayKeys = ['street', 'locality', 'postal_code']
    autoAddressKeyToForm = {
        street: 'street_address',
        locality: 'city',
        administrative_area: 'state',
        postal_code: 'zip_code'
    }

    chainAddress = {
        isChainAddress: true,
        groupAddress: ['district_selection', 'city_selection', 'street1']
    }

    uuid = ''
    selectedShippingPaymentOption = null

    toFormat = {
        enroll: {
            uuid: this.GetUuid(),
            city: '',
            zip: '',
            email: '',
            phone: '',
            password: '',
            shipment_options: 'aramex'
        },
        enrollWithReferral: {
            uuid: this.GetUuid(),
            city: '',
            zip: '',
            email: '',
            phone: '',
            password1: '',
            password2: '',
            shipment_options: 'aramex'
        },
        shop: {
            uuid: this.GetUuid(),
            city: '',
            zip: '',
            email: '',
            shipment_options: 'aramex'
        }
    }

    formShop = {
        fullName: '',
        email: '',
        phone: '',
        city: '',
        state: '',
        zip_code: ''
    }

    createAccountWithShippingAddress = {
        type: 'enroll',
        referral_id: '',
        firstname_en: '',
        lastname_en: '',
        email: '',
        phone: '',
        password: '',
        district: '',
        city: '',
        zip: '',
        period: '',
        shipment_options: 'aramex'
    }

    ExcludedFieldsShippingIfCreateAccount = ['fullName']

    ExcludedFieldsShipping = []

    mapFormKeyToFormatKey = {
        fullName: 'fullname',
        zip_code: 'zip',
        firstname: 'firstname_en',
        lastname: 'lastname_en',
        district: 'district',
        city_selection: 'city',
        district_selection: 'district',
        region_select: 'region',
        // city_select: 'city',
        delivery_center: 'delivery'
    }

    ArrangeCreateCheckoutForm = [
        'firstname',
        'lastname',
        'email',
        'password',
        'phone',
        'country',
        'region_select',
        'city_select',
        'delivery_center',
        'street1',
        'street2',
        'district_selection',
        'state',
        'city_selection',
        'zip_code'
    ]

    PaymentStep = {
        payment: 0,
        createOrder: 0,
        autoship: -2,
        updateLog: 0
    }

    breadcrumbOption = [
        {
            caption: 'customise',
            link: '/products',
            paramsRequire: false
        },
        {
            caption: 'signup_shipping',
            link: '/checkout/create-account',
            paramsRequire: true,
            authCaption: 'shipping',
            authLink: '/checkout/shipping'
        },
        {
            caption: 'purchase',
            link: '/checkout/payment',
            paramsRequire: true
        }
    ]

    shippingMethods = [
        {
            id: 1,
            api_value: 'aramex',
            title: 'aramex',
            dict_key: 'aramex',
            for_status: [],
            options: [
                {
                    id: 1,
                    title: 'creditcard',
                    dict_key: 'creditcard',
                    for_status: []
                },
                {
                    id: 2,
                    title: 'cash_on_delivery',
                    dict_key: 'cash_on_delivery',
                    for_status: ['M']
                }
            ]
        },
        {
            id: 2,
            api_value: 'ctm',
            title: 'pickup_aramex_center',
            dict_key: 'pickup_aramex_center',
            for_status: [],
            options: [
                {
                    id: 1,
                    title: 'Credit card',
                    dict_key: 'creditcard',
                    for_status: []
                }
            ]
        }
    ]

    PaymentGateway = 'hydra3ds'

    orderSummaryConfig = {
        subTotal: {
            display: true,
            dict_key: 'subtotal'
        },
        shipping: {
            display: true,
            dict_key: 'shipping'
        },
        productCredit: {
            display: true,
            dict_key: 'product_credit',
            icon: true,
            allowToUse: []
        },
        vat: {
            display: false,
            dict_key: 'vat',
            value: 0.2 // 20%
        },
        shippingWithoutMethod: {
            display: true,
            displayStep: ['create-account', 'shipping', 'payment'],
            dict_key: 'shipping'
        }
    }

    landingLayouts = [
        {
            nameComponent: 'banner',
            titleContent: 'mainBanner',
            style: {}
        },
        {
            nameComponent: 'ourApproach',
            titleContent: 'ourApproach',
            style: {
                minHeight: '0px'
            }
        },
        {
            nameComponent: 'theProducts',
            titleContent: 'theProducts',
            style: {
                backgroundColor: '#F1F6FB'
            }
        },
        {
            nameComponent: 'thePractice',
            titleContent: 'thePractice',
            style: {}
        },
        {
            nameComponent: 'howItWorks',
            titleContent: 'howItWorks',
            style: {
                backgroundColor: '#FBF7F1'
            }
        },
        {
            nameComponent: 'whatExpertsSay',
            titleContent: 'expertsSay',
            style: {}
        },
        {
            nameComponent: 'realResults',
            titleContent: 'realResults',
            style: {
                backgroundColor: '#F2F9F8'
            }
        }
    ]

    productLayouts = [
        {
            nameComponent: 'productDetailSelection',
            titleContent: 'productDetailSelection',
            style: {}
        },
        {
            nameComponent: 'theProducts',
            titleContent: 'theProducts',
            style: {}
        },
        {
            nameComponent: 'frequentlyAskedQuestions',
            titleContent: 'questions',
            style: {
                backgroundColor: '#F6F9FC'
            }
        }
    ]

    ExtendCreateAccountForms = [
        {
            key: 'region_select',
            args: null,
            type: 'select',
            label: 'region_select',
            value: '',
            placeholder: 'select_region'
        },
        {
            key: 'city_select',
            args: null,
            type: 'select',
            label: 'city_select',
            value: '',
            placeholder: 'select_city'
        },
        {
            key: 'delivery_center',
            args: null,
            type: 'select',
            label: 'delivery_center_select',
            value: '',
            placeholder: 'select_delivery_center'
        }
    ]

    ExtendShippingForms = [
        {
            key: 'region_select',
            args: null,
            type: 'select',
            label: 'region_select',
            value: '',
            placeholder: 'select_region'
        },
        {
            key: 'city_select',
            args: null,
            type: 'select',
            label: 'city_select',
            value: '',
            placeholder: 'select_city'
        },
        {
            key: 'delivery_center',
            args: null,
            type: 'select',
            label: 'delivery_center_select',
            value: '',
            placeholder: 'select_delivery_center'
        }
    ]

    PickupShippingForms = [
        {
            key: 'district_selection',
            args: null,
            type: 'select',
            label: 'select_region',
            value: '',
            placeholder: 'select_your_district'
        },
        {
            key: 'city_selection',
            args: null,
            type: 'select',
            label: 'select_city',
            value: '',
            placeholder: 'select_your_city'
        },
        {
            key: 'street1',
            args: null,
            type: 'text',
            label: 'select_delivery_center',
            value: '',
            placeholder: 'select_delivery_center'
        }
    ]

    StatesList() {
        let items = []
        Cities.map(raw => {
            items.push({
                text: raw.abbreviation,
                value: raw.abbreviation,
                html: `<span>${raw.name}</span>`
            })
        })
        return items
    }

    AddressOptionList(key = '', fn) {
        const shippingMethod = get(StoreCheckout.GetShippingMethod(), 'api_value')
        const Address = StoreTranslate.CurrentLanguage() === 'EN' ? AddressEN : AddressAR
        let items = { city: [], district: [], street1: [] }

        if (shippingMethod === 'aramex') {
            // Delivery Part

            const districtValue = get(
                (fn.GetCheckoutForms() || []).find(item => item.key === 'district_selection'),
                'value'
            )

            // city data
            const district = Object.keys(Address)

            district.map(raw => {
                items = {
                    ...items,
                    district: [
                        ...items.district,
                        {
                            text: raw,
                            value: raw,
                            html: `<span>${raw}</span>`
                        }
                    ]
                }
            })

            if (districtValue) {
                // check
                Object.keys(get(Address, districtValue, {})).map(raw => {
                    items = {
                        ...items,
                        city: [
                            ...items.city,
                            {
                                text: raw,
                                value: raw,
                                html: `<span>${raw}</span>`
                            }
                        ]
                    }
                })
            } else {
                items = {
                    ...items,
                    city: []
                }
            }
        }

        if (shippingMethod === 'ctm') {
            // Pickup part
            const districtValue = get(
                (fn.GetCheckoutForms() || []).find(item => item.key === 'district_selection'),
                'value'
            )

            const cityValue = get(
                (fn.GetCheckoutForms() || []).find(item => item.key === 'city_selection'),
                'value'
            )

            const district = Object.keys(pickupAddress)

            district.map(raw => {
                items = {
                    ...items,
                    district: [
                        ...items.district,
                        {
                            text: raw,
                            value: raw,
                            html: `<span>${raw}</span>`
                        }
                    ]
                }
            })

            if (districtValue) {
                Object.keys(get(pickupAddress, districtValue, {})).map(raw => {
                    items = {
                        ...items,
                        city: [
                            ...items.city,
                            {
                                text: raw,
                                value: raw,
                                html: `<span>${raw}</span>`
                            }
                        ]
                    }
                })
            } else {
                items = {
                    ...items,
                    city: []
                }
            }

            if (cityValue) {
                Object.keys(get(pickupAddress, [districtValue, cityValue], {})).map(raw => {
                    items = {
                        ...items,
                        street1: [
                            ...items.street1,
                            {
                                text: raw,
                                value: raw,
                                html: `<span>${raw}</span>`
                            }
                        ]
                    }
                })
            } else {
                items = {
                    ...items,
                    street1: []
                }
            }
        }

        let regexPattern = /(_selection|_select|_center)/g

        return items[key.replace(regexPattern, '')]
    }

    MapAutoAddressToForm(form, autoAddressData) {
        const swappedValuesAsKeys = ObjectHelpers.swapKeysAndValues(this.autoAddressKeyToForm)
        return form.map(item => {
            if (swappedValuesAsKeys[item.key]) {
                if (autoAddressData.data) {
                    item.value = autoAddressData.data[swappedValuesAsKeys[item.key]]
                }
            }

            return item
        })
    }

    FormToFormat(type, form) {
        form.map(item => {
            if (this.mapFormKeyToFormatKey[item.key]) {
                if (this.toFormat[type]) {
                    runInAction(() => {
                        this.toFormat[type][this.mapFormKeyToFormatKey[item.key]] = item.value
                    })
                }
            } else {
                if (this.toFormat[type]) {
                    runInAction(() => {
                        this.toFormat[type][item.key] = item.value
                    })
                }
            }

            return item
        })
    }

    SetUuid(value) {
        this.uuid = value
    }

    GetUuid() {
        return this.uuid
    }

    GetFormat(type) {
        return this.toFormat[type]
    }

    GetPaymentStep() {
        return this.PaymentStep
    }

    GetBreadcrumbOption() {
        return this.breadcrumbOption
    }

    GetShippingMethod() {
        return this.shippingMethods
    }

    GetPageConfig() {
        return this.pageConfig
    }

    SetPaymentStep(key, value) {
        this.PaymentStep[key] = value
    }

    GetOrderSummaryConfig() {
        return this.orderSummaryConfig
    }

    SetSelectedShippingPaymentOption(value) {
        this.selectedShippingPaymentOption = value
    }

    GetSelectedShippingPaymentOption() {
        return this.selectedShippingPaymentOption
    }

    GetLandingLayout() {
        return this.landingLayouts
    }

    GetProductLayout() {
        return this.productLayouts
    }

    GetBranchPickupDetail() {
        const regionValue = get(
            (StoreCheckout.GetCheckoutForms() || []).find(item => item.key === 'district_selection'),
            'value'
        )

        const cityValue = get(
            (StoreCheckout.GetCheckoutForms() || []).find(item => item.key === 'city_selection'),
            'value'
        )

        const addressValue = get(
            (StoreCheckout.GetCheckoutForms() || []).find(item => item.key === 'street1'),
            'value'
        )
        return get(pickupAddress, [regionValue, cityValue, addressValue], []).find(item => item.ADDRESS === addressValue) || {}
    }

    /**
     *
     * @param {*} uuid
     * @param {object} detailPage { products, detailPage, isSubscribe, isEnroll, type}
     * @param {*} CreditCardEncrypted
     */
    async SubmitPayment(uuid, detailPage, CreditCardEncrypted, products) {
        try {
            sessionStorage.setItem('uuid', uuid)
            sessionStorage.setItem('detailPage', JSON.stringify(detailPage))
            const Pay = new Payment(uuid, detailPage)
            const responsePreparePayment = await Pay.PreparePaymentData()

            // const allowCreditEnable = StoreAuth.IsAllowCredit()

            if (!Pay.hydra.transactions) {
                Pay.hydra.transactions = {}
            }

            Pay.hydra.transactions = {
                items: [
                    {
                        amount: 'this.terms.total',
                        type: 'IOU',
                        method: 'CreditCard',
                        billToEmail: responsePreparePayment.data.data.hydra.shipToEmail,
                        billToPhone: responsePreparePayment.data.data.hydra.shipToPhone,
                        methodDetails: {
                            payer: responsePreparePayment.data.data.hydra.shipToName.firstName,
                            bankName: 'PayMob'
                        }
                    }
                ]
            }

            await Pay.PostToHydra()

            await Pay.UpdatePayMobLog('waiting')

            return {
                success: true,
                payment_id: responsePreparePayment.data.data.payment_id,
                orderData: Pay.orderData
            }
        } catch (error) {
            console.log(error)
            runInAction(() => {
                StorePaymentStep.PaymentDone = true
            })

            return { success: false }
        }
    }

    async CreateAccount(uuid, accForm, shippingForm, referral, cartItems) {
        try {
            const forms = Object.assign(this.createAccountWithShippingAddress, accForm)
            const returnShippingAddress = {}
            shippingForm.map(item => {
                if (this.ExcludedFieldsShippingIfCreateAccount.includes(item.key)) {
                    return false
                }
                if (this.mapFormKeyToFormatKey[item.key]) {
                    forms[this.mapFormKeyToFormatKey[item.key]] = item.value
                    returnShippingAddress[this.mapFormKeyToFormatKey[item.key]] = item.value
                } else {
                    forms[item.key] = item.value
                    returnShippingAddress[item.key] = item.value
                }
            })

            if (referral) {
                forms.referral_id = referral
            } else {
                delete forms.referral_id
            }

            delete forms.country

            if (!StoreCheckout.shippingMethod) {
                return {
                    success: false,
                    shippingMethodIsRequired: true
                }
            }

            const periodResponse = await FeelGreatAPI.GetPeriod('EG')
            forms.period = periodResponse.data.entryPeriod
            forms.uuid = uuid

            forms.shipment_options = StoreCheckout.shippingMethod.api_value
            forms.shipment_packs = JSON.stringify(cartItems)
            const url = `https://${ServerEnv.MemberCalls2()}.unicity.com/hot/formatV2/EGY/feelGreat/createAccount${
                ServerEnv.ENV === 'DEV' ? '?dev=1' : '?emailDelay=1h'
            }`
            const response = await axios.post(url, forms)

            return {
                ...response.data,
                form: forms
            }
        } catch (e) {
            console.error(e)

            return {
                success: false
            }
        }
    }

    SpecialAreasDeliveryFeeCondition(step) {
        let totalPrice = 0

        const shippingMethod = storeCheckout.GetShippingMethod()
        if (!shippingMethod) return totalPrice

        // has shipfee for delivery
        if (!this.orderSummaryConfig.shippingWithoutMethod.displayStep.includes(step)) return totalPrice

        const products = toJS(StoreProducts.GetProducts())
        const onetimeItems = get(storeCheckout.GetCart(), 'onetime')
        const onetime5PacksItems = get(storeCheckout.GetCart(), 'onetime5Packs')
        const subscribeItems = get(storeCheckout.GetCart(), 'subscribe')
        let totalPV = 0

        if (!isEmpty(onetimeItems)) {
            const onetimeProducts = Object.keys(onetimeItems)
            onetimeProducts.forEach(item => {
                const productPV = get(products, [item, 'onetime', 'pv'], 0)
                const productQty = get(onetimeItems, item, 0)
                totalPV = totalPV + productPV * productQty
            })
        }

        if (!isEmpty(onetime5PacksItems)) {
            const onetime5PacksProducts = Object.keys(onetime5PacksItems)
            onetime5PacksProducts.forEach(item => {
                const productPV = get(products, [item, 'onetime5Packs', 'pv'], 0)
                const productQty = get(onetime5PacksItems, item, 0)
                totalPV = totalPV + productPV * productQty
            })
        }

        if (!isEmpty(subscribeItems)) {
            const subscribeProducts = Object.keys(subscribeItems)
            subscribeProducts.forEach(item => {
                const productPV = get(products, [item, 'subscribe', 'pv'], 0)
                const productQty = get(subscribeItems, item, 0)
                totalPV = totalPV + productPV * productQty
            })
        }

        if (totalPV >= 100) return totalPrice

        if (get(shippingMethod, 'api_value') === 'aramex') {
            totalPrice += 60
        } else if (get(shippingMethod, 'api_value') === 'ctm') {
            totalPrice += 25
        }

        return totalPrice
    }

    cityOptionList = null

    setCityOptionList(isSwitchLanguage = false) {
        if (this.cityOptionList !== null && isSwitchLanguage === false) return

        let options = []
        if (Cities.length > 0) {
            const isEng = localStorage.getItem('currentLanguage') === 'EN'
            const optionLanguage = isEng ? 'city_roman' : 'city_native'

            options = Cities.map(item => {
                return {
                    text: item[`${optionLanguage}`],
                    value: item[`${optionLanguage}`],
                    html: `<span>${item[`${optionLanguage}`]}</span>`
                }
            })
        }
        this.cityOptionList = options

        return
    }

    getCityOptionList() {
        return this.cityOptionList
    }

    constructor() {
        StorePaymentStep.SetPaymentSteps(this.PaymentStep)
        this.setCityOptionList()
        makeAutoObservable(this)
    }
}

export default Egypt
